import React, {useState } from "react";
import "./videoBanner.css";
import {Button} from "@kui-react/button";
import { Select } from '@kui-react/select'


const Index = ({ banner, setOpenPreviewModal, setCurrentVideoUrl, etailCall }) => {
  var videoUrl = banner?.youTubeLink.split("|")?.[0];
  const baseURL = process.env.REACT_APP_ASSETS_URL;
  const videoBaseUrl = process.env.REACT_APP_VIDEO_ASSETS_URL;
  var srcSet = "";
  banner?.imgSrcSet.forEach((src, index) => {
    srcSet = srcSet + (baseURL + "" + src);
    if (index < banner.imgSrcSet.length - 1) {
      srcSet = srcSet + ",";
    }
  });
  const playVideoInIframeDiv = (id, url) => {
    etailCall('VIDEO_CLICK', id);
    // var iframeVideo = document.getElementById(id);
    // iframeVideo.attributes({ src: url + "?autoplay=1" });
  };

  // eslint-disable-next-line
  const [shouldPlay, setShouldPlay] = useState(new Array(banner.order).fill(false));
  // eslint-disable-next-line
  const [age, setAge] = useState('');
  const [videoIndex, setvideoIndex] = useState(null);
  const handleFormSubmit = (event) => {
    event.preventDefault();
    if (day && month && year) {
      // Calculate age based on the selected date of birth
      const dob = new Date(`${month}/${day}/${year}`);
      const today = new Date();
      const diff = today - dob;
      const ageInYears = Math.floor(diff / (365.25 * 24 * 60 * 60 * 1000));

      setAge(ageInYears);
      // Check if the person is old enough (e.g., 18 years)
      if (parseInt(ageInYears, 10) >= 17) {
        let videoAgeElement = document.getElementById(`ageConfirm_${videoIndex}`)
        videoAgeElement.style.display = 'none'
        etailCall('VIDEO_CLICK', banner.title)
        //code for playing video start
        setShouldPlay((prevShouldPlay) => {
          const updatedShouldPlay = [...prevShouldPlay];
          updatedShouldPlay[videoIndex] = true;
          let videoElement = document.getElementById(`video_${videoIndex}`);
          if (videoElement) {
            if (updatedShouldPlay[videoIndex]) {
              videoElement.play();
              setPlay(true)
            } else {
              videoElement.pause();
              videoElement.currentTime = 0;
            }
          }
          return updatedShouldPlay;
        });
        //code for playing video end
        return
      } else {
        // Display a message or take other actions for underage users
        // alert('Sorry, you must be at least 18 years old to watch this video.');
        let videoAgeDetailElement = document.getElementById(`ageConfirmDetail_${banner?.order}`)
        debugger
        videoAgeDetailElement.textContent= 'Sorry, this content is age-restricted.'
      }
      // You can also include the form submission logic here
      // console.log(`Date of Birth: ${day}/${month}/${year}, Age: ${ageInYears}`);
    }
  };
  const handleBannerClick = (videoIndex) => {
    // let videoAgeElement = document.getElementById(`ageConfirm_${banner?.order}`)
    // setTimeout(() => {
    //   videoAgeElement.style.display = 'block'
    // }, 500);
   
    setvideoIndex(banner?.order)
  };
  //code for age check start
  const [day, setDay] = useState('1');
  const [month, setMonth] = useState('January');
  const [year, setYear] = useState('2023');
  const days = Array.from({ length: 31 }, (_, i) => i + 1);
  const daysWithLabels = days.map(day => ({ label: `${day}`, value: day }));
  const monthsArray = [
    { label: 'January', value: 'January' },
    { label: 'February', value: 'February' },
    { label: 'March', value: 'March' },
    { label: 'April', value: 'April' },
    { label: 'May', value: 'May' },
    { label: 'June', value: 'June' },
    { label: 'July', value: 'July' },
    { label: 'August', value: 'August' },
    { label: 'September', value: 'September' },
    { label: 'October', value: 'October' },
    { label: 'November', value: 'November' },
    { label: 'December', value: 'December' }];
  const years = Array.from({ length: 100 }, (_, i) => new Date().getFullYear() - i);
  const yearsWithLabels = years.map(year => ({ value: year, label: `${year}` }));
  // Determine if the submit button should be disabled
  // const isSubmitDisabled = !day || !month || !year;

  //code for age check end

  const [play, setPlay] = React.useState(false);
  const url = play
    ? videoUrl + `?autoplay=1`
    : videoUrl;
  return banner && banner?.youTubeLink ? (
    !banner?.youTubeLink?.includes("youtube") ? (

      <div className="VideoBannerUpload" key={banner?.order}>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a title={banner?.title} className={play ? 'img-hide' : 'img-responsive'} onClick={() => handleBannerClick(banner?.order)}></a>
         <div style={{visibility:videoIndex === banner?.order?'visible':'hidden' }} className="img-responsiveForm" id={`ageConfirm_${banner?.order}`}>
          <p className="agePopupHeader">Age Verification</p>
          <p id={`ageConfirmDetail_${banner?.order}`} className="agePopupDetails">Please enter your date of birth to view the video:</p>
          <form onSubmit={handleFormSubmit}>
            {/* <label className="ageLabel" htmlFor="age">Enter your age:</label>
            <input
            className="ageInput"  
              type="number"
              id="age"
              name="age"
              value={age}
              onChange={(e) => setAge(e.target.value)}
              required
            /> */}
            <div className="dataBirth">
              <div className="nv-select">
                <Select
                  closeMenuOnSelect={true}
                  options={monthsArray}
                  width="130px"
                  placeholder={month}
                  value={month}
                  onChange={(e) => setMonth(e?.value)}
                ></Select></div>
              <div className="nv-select">
                <Select
                  closeMenuOnSelect
                  options={daysWithLabels}
                  width="60px"
                  placeholder={day}
                  value={day}
                  onChange={(e) => setDay(e?.value)}
                ></Select></div>
              <div className="nv-select" style={{ 'padding-right': '3em' }}>
                <Select
                  closeMenuOnSelect
                  options={yearsWithLabels}
                  width="80px"
                  placeholder={year}
                  value={year}
                  onChange={(e) => setYear(e?.value)}
                ></Select></div>
              <Button
                shape="rectangle"
                size="regular"
                tag="button"
                variant="solid"
                className="submitButton"
                // onClick={() => setIsOpen((x) => !x)}
                onClick={handleFormSubmit}
                type="submit"
              >
                Submit
              </Button>
            </div>

          </form>
        </div>
        <video
          role="banner"
          aria-label="Promo Banner"
          style={{ cursor: "pointer" }}
          id={`video_${banner?.order}`}
          width="100%"
          title={banner.title}
          height="100%"
          controls
          poster={videoBaseUrl + banner.imgSrc}
          loading="lazy"
        >
          <source src={videoBaseUrl + videoUrl} type="video/mp4"></source>
        </video>
      </div>




    ) : (
      <>
        <div className="VideoBanner">
           {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a
          title={banner?.title}
          className={play ? 'img-hide' :'img-responsive'}
          onClick={() => {setPlay(true); playVideoInIframeDiv(banner.title,videoUrl);}}
          ></a>
          <iframe

            id={'VideoIframe'}
            key={banner.title}
            width="100%"
            height="100%"
            src={url}
            allowFullScreen=""
            title={banner.title}
            loading="lazy"
          ></iframe>
        </div>


      </>
    )
  ) : banner?.type === "image" || banner.videoType === "url" ? (
    <div
      className={banner.youTubeLink?.length > 0 ? "cursorPointer" : ""}
      onClick={() => {
        setOpenPreviewModal(true);
        setCurrentVideoUrl(banner.youTubeLink);
      }}
    >
      {/* <a href={banner.youTubeLink}> */}
      <img
        srcSet={srcSet}
        src={banner?.imgSrc}
        // sizes="
        // (max-width: 2000px) 2560px,
        // (max-width: 1280px) 1280px,
        // (max-width: 1024px) 1024px,
        // (max-width: 767px) 767px,
        // (max-width: 500px) 760px,
        // 1280px"
        alt={banner?.title}
        className="img-responsive"
        title={banner?.title}
        loading="lazy"
      />
      {/* </a> */}
    </div>
  ) : (
    <video
      role="banner"
      aria-label="Promo Banner"
      style={{ cursor: "pointer" }}
      id="tab1_video1"
      width="100%"
      onClick={() => { alert('video is clicked') }}
      title={banner.title}
      height="100%"
      controls
      poster={videoBaseUrl + banner.imgSrc}
      loading="lazy"
    >
      <source
        src={videoBaseUrl +videoUrl}
        type="video/mp4"
      ></source>
    </video>
  );
};

export default Index;
